module.exports = __webpack_public_path__ + "img/pumping-activities-btn.29ee9f44.png";